import Image from 'next/image'
import { ArrowRight, BookOpen, Calculator, ClipboardList, GitCompareArrows, ListTree, MapPin, Newspaper, PlugZap, Receipt, Recycle, Refrigerator, Ruler, Store, type LucideIcon } from 'lucide-react'

const photos: Record<string, { src: string; alt: string }> = {
  '/best-refrigerators': { src: '/homepage-2026/hero/fridge-com-lg-lryxc2606d-1.jpg', alt: 'French-door refrigerator — Fridge.com' },
  '/best-freezers': { src: '/homepage-2026/black-freezer-cutout.png', alt: 'Upright freezer — Fridge.com' },
  '/energy-efficiency-guide': { src: '/homepage-2026/qa-energy-kitchen.jpg', alt: 'Refrigerator in a home kitchen — Fridge.com' },
  '/parts': { src: '/homepage-2026/qa-fridge-parts.jpg', alt: 'Open refrigerator freezer drawer and bin — Fridge.com' },
  '/filters': { src: '/homepage-2026/qa-water-filter.jpg', alt: 'Refrigerator water filter cartridge — Fridge.com' },
}

const diagrams: Record<string, { first: LucideIcon; second: LucideIcon; label: string }> = {
  '/refrigerator-buying-guide': { first: Ruler, second: Refrigerator, label: 'Measure the space and choose an appliance' },
  '/tools': { first: Refrigerator, second: Calculator, label: 'Calculate costs and compare appliance choices' },
  '/local': { first: MapPin, second: PlugZap, label: 'Explore electricity context by location' },
  '/rebates': { first: Refrigerator, second: Receipt, label: 'Find appliance incentive programs' },
  '/recycling-guide': { first: Refrigerator, second: Recycle, label: 'Find a recycling route for an old appliance' },
  '/compare': { first: Refrigerator, second: GitCompareArrows, label: 'Compare appliance specifications and prices' },
  '/blogs/news': { first: Newspaper, second: BookOpen, label: 'Read appliance news and buying guides' },
  '/brands': { first: Store, second: Refrigerator, label: 'Explore appliance brands' },
  '/sitemap': { first: ListTree, second: ClipboardList, label: 'Browse the directory of site pages' },
}

/** Existing approved photography and symbolic diagrams; no invented offers or data. */
export function ExploreVisual({ href }: { href: string }) {
  const photo = photos[href]
  if (photo) return (
    <div className="relative h-full min-h-28 sm:aspect-[2/1] sm:min-h-0 bg-white" data-explore-visual="photo">
      <Image src={photo.src} alt={photo.alt} fill sizes="(max-width: 639px) 104px, (max-width: 1023px) 45vw, 30vw" className="object-contain p-2" />
    </div>
  )
  const diagram = diagrams[href]
  if (!diagram) return null
  const First = diagram.first
  const Second = diagram.second
  return (
    <div role="img" aria-label={`${diagram.label} — Fridge.com`} data-explore-visual="diagram" className="flex h-full min-h-28 items-center justify-center gap-1 bg-[#f0f6ff] sm:aspect-[2/1] sm:min-h-0 sm:gap-4">
      <First aria-hidden="true" className="h-8 w-8 text-[#0469f0] sm:h-12 sm:w-12" strokeWidth={1.5} />
      <ArrowRight aria-hidden="true" className="h-4 w-4 text-[#b25410] sm:h-5 sm:w-5" />
      <Second aria-hidden="true" className="h-8 w-8 text-[#0469f0] sm:h-12 sm:w-12" strokeWidth={1.5} />
    </div>
  )
}
